var ComponentQuestionnaireTitle = (function () {
    function ComponentQuestionnaireTitle() {
    }
    ComponentQuestionnaireTitle.prototype.ngOnInit = function () {
    };
    ComponentQuestionnaireTitle.prototype.ngAfterViewInit = function () {
    };
    return ComponentQuestionnaireTitle;
}());
export { ComponentQuestionnaireTitle };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-title/component.questionnaire-title.ts.pre-build-optimizer.js